import { ChamadoTecnicoAnexoService } from '@/features/chamados/services/chamado-tecnico-anexo.service'
import { CallTechUserImage as CallTechAttachment } from '@/services/backend/config/entities'

import { EvidenceCreateDialog } from '../evidencia/evidence-create-dialog'

type Props = {
  callId: number
  onSuccess: (data: CallTechAttachment) => void
}

export default function Component(props: Props) {
  return (
    <EvidenceCreateDialog
      {...props}
      repository={ChamadoTecnicoAnexoService}
    />
  )
}
